import { postAxios, postFileUploadAxios, postOrderFileUploadAxios } from '@/components/common/http'
export const convertApi = {
  // 上传其它转pdf文件
  convertToPdf: (data) => {
    return postFileUploadAxios('/api/v1/wps/file/convert', data)
  },
  // 请求其它转pdf文件
  getConvertPdf: (data) => {
    return postAxios('/api/v1/wps/file/get', data)
  },
  // 提交PDF转Other原始文件
  commitPdfToOther: (data, order) => {
    return postOrderFileUploadAxios('/api/v1/wps/pdf/commit', data, order)
  },
  // 获取PDF转其它提交文件
  getPdfToOther: (data) => {
    return postAxios('/api/v1/wps/pdf/get', data)
  }
}



// WEBPACK FOOTER //
// ./src/components/convert/convert.js